<template>
  <button type="button" class="table-button" v-bind="btnProps">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "TableButton",
  inheritAttrs: false
}
</script>

<script setup>
import { computed, useAttrs } from "vue"

const props = defineProps({
  disabled: { type: Boolean, default: false },
  plain: { type: Boolean, default: false },
  color: { type: String, default: "blue" }
})
const attrs = useAttrs()
const btnProps = computed(() => {
  const { class: classes, ...other } = attrs
  return {
    class: [
      classes,
      `btn-${props.color}`,
      {
        "is-plain": props.plain,
        "is-disabled": props.disabled
      }
    ],
    disabled: props.disabled,
    ...other
  }
})
</script>

<style lang="less" scoped>
.table-button {
  --color: #ffffff;
  --bg: #428bca;
  --border: #428bca;
  --hover-bg: #1c70a9;
  --hover-border: #1c70a9;
  display: inline-block;
  padding: 18px 24px;
  border-radius: 40px;
  line-height: 22px;
  font-size: var(--fs-14);
  color: white;
  border-width: 1px;
  border-style: solid;
  border-color: var(--border);
  background-color: var(--bg);
  color: var(--color);
  cursor: pointer;
  &[disabled] {
    cursor: not-allowed;
  }
  &:hover {
    border-color: var(--hover-border);
    background-color: var(--hover-bg);
  }
  &.btn-orange {
    --color: #ffffff;
    --bg: #fb8542;
    --border: #fb8542;
    --hover-bg: #cc5b1a;
    --hover-border: #cc5b1a;
  }
  &.btn-red {
    --color: #ffffff;
    --bg: #ff3c3c;
    --border: #ff3c3c;
    --hover-bg: #e94148;
    --hover-border: #e94148;
  }
  &.btn-green {
    --color: #ffffff;
    --bg: #5fb750;
    --border: #5fb750;
    --hover-bg: #61ad54;
    --hover-border: #61ad54;
  }
  &.btn-grey {
    --color: #ffffff;
    --bg: #999;
    --border: #999;
    --hover-bg: #999;
    --hover-border: #999;
  }
  &[disabled],
  &.is-disabled {
    --color: #ffffff !important;
    --bg: #999 !important;
    --border: #999 !important;
    --hover-bg: #999 !important;
    --hover-border: #999 !important;
  }
}
</style>
